import { useEffect, useState } from "react";
import Select from "react-select";
import { Checkbox, Grid, Popup } from "semantic-ui-react";
import { useGetProductCalculateSales } from "../../../api/product";
import FilterIcon from "../../../assets/commonIcon/FilterIcon";
import { CustomButton } from "../../../components/button/Button";
import { TitleView } from "../../../components/titleView/TitleView";
import { getClientRequestFilters, saveClientRequestFilters } from "../../../utils/cacheStorage";

const MappingRepliesFilter = ({ refetchWithFilters }: any) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState<any>([] as any);
  const [sortBy, setSortBy] = useState<number>(0);

  const { data: productSalesUnitsData } = useGetProductCalculateSales({ searchKey: "" });

  const currentProductData = productSalesUnitsData?.map((item: any) => {
    return {
      value: item._id,
      label: `${item.productName} - ${item.salesUnitName}`,
      productId: item.productId,
      salesUnitId: item.salesUnitId
    };
  });

  useEffect(() => {
    const getInitClientRequestFilters = () => {
      const { currentFilterProductIds, requestStatus } = getClientRequestFilters();
      const availableProductIds = currentFilterProductIds
        ? JSON.parse(currentFilterProductIds)
        : [];

      if (availableProductIds || requestStatus) {
        setSelectedProducts(availableProductIds);
        setSortBy(requestStatus ? Number(requestStatus) : 0);
      }
    };

    getInitClientRequestFilters();
  }, []);

  const resetValue = () => {
    setSelectedProducts([]);
    setSortBy(0);
    const emptyProducts: any[] = [];
    const defaultSort = 0;
    setSelectedProducts(emptyProducts);
    setSortBy(defaultSort);
    saveClientRequestFilters(emptyProducts, defaultSort);
    refetchWithFilters(emptyProducts, defaultSort);
    setIsPopupOpen(false);
  };

  const filterValue = () => {
    saveClientRequestFilters(selectedProducts, sortBy);
    refetchWithFilters(selectedProducts, sortBy);
    setIsPopupOpen(false);
  };

  return (
    <Popup
      open={isPopupOpen}
      on="click"
      onOpen={() => setIsPopupOpen(true)}
      onClose={() => {
        setIsPopupOpen(false);
      }}
      size="large"
      position={"bottom left"}
      trigger={
        <Grid>
          <CustomButton
            className="filterButton"
            iconWithText
            iconChild={<FilterIcon />}
            buttonOutLine
            theme="green"
            title="Filters"
            iconChildTextCustom={"productCustomBase"}
          />
        </Grid>
      }
    >
      <Grid className="productFilterMainView">
        <Grid.Column>
          <TitleView title={"Sort By"} />
          <Grid>
            <Grid.Column computer={8} tablet={8} mobile={16}>
              <p className={`productFilterTitle`}>Product Name</p>
              <Select
                value={selectedProducts}
                onChange={(e: any) => {
                  setSelectedProducts(e);
                }}
                isMulti
                options={currentProductData || []}
              />
            </Grid.Column>
          </Grid>
          <p className="productFilterSortResultTitle mt-1">Sort Result</p>
          <Grid>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Checkbox
                onClick={() => setSortBy(1)}
                checked={sortBy === 1}
                radio
                label="Requested"
              />
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Checkbox
                onClick={() => setSortBy(2)}
                checked={sortBy === 2}
                radio
                label="Accepted"
              />
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Checkbox
                onClick={() => setSortBy(4)}
                checked={sortBy === 4}
                radio
                label="Mapping shared"
              />
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Checkbox
                onClick={() => setSortBy(0)}
                checked={sortBy === 0}
                radio
                label="Not relevant"
              />
            </Grid.Column>
          </Grid>
          <Grid className="pt-0">
            <Grid.Column computer={16} tablet={16} mobile={16} className="productFilterButton">
              <CustomButton
                buttonOutLine
                customBase="productFilterCustomButton"
                theme="green"
                title="Reset"
                onClick={resetValue}
              />
              <CustomButton theme="green" title="Apply" onClick={filterValue} />
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    </Popup>
  );
};

export default MappingRepliesFilter;
